export const asyncDelay = (ms: number): Promise<void> =>
  new Promise((resolve) =>
    delay(() => {
      resolve();
    }, ms)
  );

export const delay = (callback, ms) => setTimeout(callback, ms);
